import { UsersService } from "@/clients";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useUser } from "@clerk/clerk-react";
import { useMutation } from "@tanstack/react-query";

export const useDeleteUser = () => {
  const { user: clerkUser } = useUser();

  const deleteUserMutation = useMutation({
    mutationKey: [QueryKeys.DELETE_USER],
    mutationFn: async () => {
      if (!clerkUser) {
        throw new Error("Clerk user not found. Cannot complete deletion.");
      }
      const user = guardGetUserFromLocalStorage();
      const { data } = await UsersService.deleteUserApiV1UsersDelete(user.id);

      try {
        await clerkUser.delete();
      } catch (clerkError) {
        console.error("Error deleting user from Clerk:", clerkError);
        throw new Error("Failed to delete user from authentication service.");
      }

      return data;
    },
  });

  return deleteUserMutation;
};
